<div class="df aic">
  @if (!isPhone) {
      <app-menu-trigger 
        [mc]="this" 
        (onclick)="onclicktrigger.emit()"
        [isOn]="'menu'"
      >
    </app-menu-trigger>
    <img [go]="v.dashboard" class="logoToolbar cp" [ngClass]="{'dn' : !opened}"
      src="./assets/img/logos/backoffice-logo-white.png">
  }
</div>

<!-- menu.component.html -->
<div #menu class="menu" 
     (mouseleave)="onMouseLeaveComponent()" 
     [ngClass]="!opened && isDesktop ? 'menu-closed' : ''">
  
  <div (mouseenter)="onMouseEnterComponent()">
    
    <!-- Menú dinámico -->
    @for(item of menuItems; track item.id) {
      
          @if (!item.children) {
            <!-- Item simple -->
            <app-menu-item
              [menuItemPermissions]="item.requiredPermissions"
              [isDesktopMenu]="isDesktop"
              [menuOpened]="opened"
              [data]="item"
              [showAttentionDot]="item.view!.path == v.feedback.path && feedbackS.unreadCount() > 0"
              (afterGo)="afterGoTo()"
            >
            </app-menu-item>
          } @else {
            <!-- Item con submenú -->
            <app-multiple-menu-item
              [id]="item.id"
              [data]="item"
              [parent]="this">
            </app-multiple-menu-item>
          }

    }
    
    
  </div>
</div>